import { Routes } from '@angular/router';
import { Shell } from './layout/shell/shell';
import { authGuard } from './core/guards/auth-guard';

export const routes: Routes = [
  {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.route').then(m => m.AUTH_ROUTES),
  },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard], 
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
      },
      {
        path: 'analytics',
        loadChildren: () => import('./pages/analytics/analytics.routes').then(m => m.ANALYTICS_ROUTES),
      },
      {
        path: 'app-users',
        loadChildren: () => import('./pages/users/users.routes').then(m => m.USERS_ROUTES),
      },
      {
        path: 'content',
        loadChildren: () => import('./pages/content/content.routes').then(m => m.CONTENT_ROUTES),
      },
      {
        path: 'categories',
        loadChildren: () => import('./pages/categories/categories.routes').then(m => m.CATEGORIES_ROUTES),
      },
      {
        path: 'engagement',
        loadChildren: () => import('./pages/engagement/engagement.routes').then(m => m.ENGAGEMENT_ROUTES),
      },
      {
        path: 'gifts',
        loadChildren: () => import('./pages/gifts/gifts.routes').then(m => m.GIFTS_ROUTES),
      },
      {
        path: 'reactions',
        loadChildren: () => import('./pages/reactions/reactions.routes').then(m => m.REACTIONS_ROUTES),
      },
      {
        path: 'audio',
        loadChildren: () => import('./pages/audio/audio.routes').then(m => m.AUDIO_ROUTES),
      },
      {
        path: 'music-library',
        loadChildren: () => import('./pages/music-library/music-library.routes').then(m => m.MUSIC_LIBRARY_ROUTES),
      },
      {
        path: 'avatars',
        loadChildren: () => import('./pages/avatars/avatars.routes').then(m => m.AVATARS_ROUTES),
      },
      {
        path: 'legal-pages',
        loadChildren: () => import('./pages/legal-pages/legal-pages.routes').then(m => m.LEGAL_PAGES_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
